var reasonKeys = {
    "invalid": "two-factor-invalid-text",
    "expired": "two-factor-expired-text",
    "locked": "two-factor-locked-text",
    "throttled": "two-factor-throttled-text",
    "disabled": "two-factor-disabled-text",
    "challenge-expired": "two-factor-challenge-expired-text",
    "already-enrolled": "two-factor-already-enrolled-text",
    "not-enrolled": "two-factor-not-enrolled-text"
};
/** Reads the { reason } body a two-factor endpoint returns with a 400. */
export function getFailureReason(error) {
    return (error && error.reason) || (error && error.content && error.content.reason) || null;
}
export function translateFailure(i18n, error) {
    var key = reasonKeys[getFailureReason(error)];
    return i18n.tr(key ? key : "two-factor-error-text");
}
/** Reasons that leave no usable challenge cookie, so the user has to sign in again. */
export function requiresSignInAgain(reason) {
    return reason === "locked" || reason === "challenge-expired" || reason === "already-enrolled";
}
